import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),//路由模式
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      component: () => import('../components/index.vue'),
      meta: { title: "觉加科技" }
    },
    {
      path: '/detail',
      component: () => import('../components/detail.vue'),
      meta: { title: "觉加产品" }
    },
  ]
})

// 导航守卫

export default router